import { extendObservable, runInAction } from 'mobx';

import { MessageController } from '../../../../networking/controllers/MessageController';
import { ApiError, ERROR_STATUSES, ERROR_CODES } from '../../../../models/ApiError';
import { Logger } from '../../../../helpers/Logger';

class MessageStoreClass {
  constructor() {
    extendObservable(this, {
      message: null,

      loadingMessage: false,
      internalError: false,
      apiError: null,
      error: false,
    });
  }

  async getInformation(token) {
    runInAction(() => {
      this.loadingMessage = true;
      this.internalError = false;
      this.apiError = null;
      this.error = false;
    });
    try {
      const message = await MessageController.getMessage(token);
      message.sections.sort((a, b) => (a.order < b.order ? -1 : 1));
      runInAction(() => {
        this.message = message;
      });
    } catch (error) {
      Logger.warn(error);
      if (ApiError.isSameTypeAs(error)) {
        if (error.status >= ERROR_STATUSES.SERVER_ERROR) {
          runInAction(() => {
            this.internalError = true;
          });
        } else if (error.code === ERROR_CODES.INVALID_SERVICE_INFORMATION) {
          runInAction(() => {
            this.apiError = error.code;
          });
        } else {
          runInAction(() => {
            this.error = true;
          });
        }
      }
    } finally {
      runInAction(() => {
        this.loadingMessage = false;
      });
    }
  }

  clearErrors() {
    runInAction(() => {
      this.internalError = false;
      this.apiError = null;
      this.error = false;
    });
  }
}

const MessageStore = new MessageStoreClass();

export { MessageStore };



// WEBPACK FOOTER //
// ./src/pages/information/message/stores/MessageStore.js